import React from 'react';
import classnames from 'classnames';
import { Form } from 'tea-component';
import TextAreaMore from '@gp/components/TextAreaMore';
import { ActionItemStatusTag } from '@gp/components/StatusTag';
import { ACTION_ITEM_STATUS_MAPPING, ACTION_ITEM_STATUS_LIST } from '@gp/constants/const';

import type { IBaseProps } from '@home/types/common';
import type { IGRAction } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';

interface IGRActionsProps extends IBaseProps {
  isShowAllContent?: boolean;
  grActions?: IGRAction[] | null;
}

const GRActions: React.FC<IGRActionsProps> = (props) => {
  const { style, className, isShowAllContent = false, grActions = [] } = props;

  const showGRActions = Array.isArray(grActions) && grActions.length > 0;

  return (
    <Form.Item style={style} className={classnames('', className)} label="GR Action Items">
      <Form.Text className="dbg-milestone-form-text">
        <div className="gp-word-break-word gp-inital-list-style dbg-milestone-form-gr">
          {showGRActions || '-'}
          {showGRActions &&
            grActions.map((grAction, grActionIdx) => {
              const grActionState = grAction?.state;
              const grActionStateComment = grAction?.state_comment?.trim();
              const grActionStateCode = ACTION_ITEM_STATUS_MAPPING[grActionState?.toLowerCase()];
              const isGrActionStateMatchedCode =
                ACTION_ITEM_STATUS_LIST.includes(grActionStateCode);
              return (
                <div key={grActionIdx} className=" dbg-milestone-gr-item">
                  <p className={`dbg-milestone-gr-item-fir`}>
                    <span className="dbg-milestone-gr-item-category">
                      {grAction?.category?.trim() || '-'}
                    </span>{' '}
                    Due: {grAction?.due_date || '-'} {grAction?.user?.trim() || '-'}
                  </p>
                  <TextAreaMore
                    className="gp-word-break-word  gp-wang-edit-content dbg-history-info"
                    text={grAction?.action_content?.trim() || '-'}
                    type="ellipsis"
                    isJsComputed
                    isMustNoButton
                    isShowAllContent={isShowAllContent}
                    textSize={14}
                    ellipsisLineClamp={2}
                    lineHeight={22}
                    // getIsFold={(v) => {
                    //   grActionIdx === 0 && setRecordsIsOverflow(v, record, records, setRecords);
                    // }}
                  />
                  <div
                    // style={{
                    //   display: isShowAllContent ? 'block' : 'flex',
                    // }}
                    className="dbg-milestone-gr-desc"
                  >
                    {!isGrActionStateMatchedCode ? (
                      <span className="dbg-milestone-gr-desc-status-tag">-</span>
                    ) : (
                      <ActionItemStatusTag
                        className="dbg-milestone-gr-desc-status-tag"
                        status={grActionStateCode}
                      />
                    )}
                    <span className="dbg-milestone-gr-desc-spliter"></span>
                    <span className="gp-word-break-word dbg-text dbg-milestone-gr-desc-comment-text">
                      {grActionStateComment || '-'}
                    </span>
                    {/* <div className="dbg-milestone-gr-desc-text">
                      {isShowAllContent ? (
                        <span className="gp-word-break-word dbg-text">{grActionStateComment || '-'}</span>
                      ) : (
                        <TextAreaMore
                          className="gp-word-break-word dbg-text gp-wang-edit-content"
                          text={grActionStateComment || '-'}
                          type="ellipsis"
                          isJsComputed
                          isMustNoButton
                          textSize={14}
                          ellipsisLineClamp={2}
                          lineHeight={22}
                          getIsFold={(v) => {
                            grActionIdx === 0 && setRecordsIsOverflow(v, record, records, setRecords);
                          }}
                        />
                      )}
                    </div> */}
                  </div>
                </div>
              );
            })}
        </div>
      </Form.Text>
    </Form.Item>
  );
};

export default GRActions;
